<template>
    <div class="okraina-phi" :class="{ unread: !item.READ, expanded: expanded, order: isOrder }" @click="onItemClick">

        <div class="top">
            <div v-if="preview" class="preview" :class="{ default: pictureIsDefault }"
                v-lazy:background-image="preview">

            </div>
            <div class="main">
                <div class="date">{{ date }}</div>
                <div class="title">{{ item.TITLE }}</div>
                <div class="body" v-html="item.BODY"></div>
            </div>
        </div>

        <Transition name="collapse">
            <div v-if="expanded" class="details">
                <div v-if="picture && !pictureIsDefault" class="picture" v-lazy:background-image="picture">
                </div>

                <div class="btn btn1 btn-block" @click="onGoClick">Перейти</div>
            </div>
        </Transition>
    </div>
</template>

<script>
import okrainaLoaderInline from "@/components/loader.inline.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import moment from "moment";
import googlePush from '@/plugins/capacitor/google.push'

import imagePushOrderPath from "@/assets/images/push-order.svg";

export default {

    name: "okraina-push-history-item",
    components: {
        okrainaLoaderInline
    },
    data() {
        return {
            expanded: false,
            imagePushOrder: imagePushOrderPath,
        };
    },
    props: {
        item: {
            type: Object,
            default() {
                return null;
            },
        },

    },
    computed: {
        date() {
            return moment(this.item.DATE, 'DD.MM.YYYY HH:mm:ss').format("DD.MM.YY HH:mm");
        },

        picture() {
            if (this.item.DATA.ICON) {
                return this.item.DATA.ICON;
            }

            return false;
        },

        pictureIsDefault() {
            if (!this.picture) {
                return false;
            }

            return this.picture.includes("push_default_picture");
        },

        preview() {
            if (this.isOrder) {
                return this.imagePushOrder
            }

            if (this.item.DATA.PREVIEW) {
                return this.item.DATA.PREVIEW;
            }

            return this.picture;
        },

        isOrder() {
            if (this.item.DATA.TYPE == "ORDER" || this.item.DATA.TYPE == "TRACKING") {
                return true;
            }
            return false;
        }
    },

    methods: {

        /**
         * Клик по заявке
         */
        onItemClick() {
            this.expanded = !this.expanded;
            if (this.expanded && !this.item.READ) {
                this.read();
            }
        },

        /**
         * Фиксация факта просмотра уведомления
         */
        read() {

            this.item.READ = true;

            rest
                .call("push.history.read", {
                    method: "post",
                    data: {
                        ID: this.item.ID,
                    },
                })
                .then((data) => {
                    if (!data.SUCCESS) {
                        this.item.READ = false;
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    } else {

                        //перезгрузим данные пользователя
                        this.$store.dispatch("loadUserData");
                    }
                });
        },

        /**
         * Клик по кнопке "Перейти"
         */
        onGoClick() {
            googlePush.onPushClick(this.item.DATA);
        }
    }
}

</script>

<style lang="scss">
.okraina-phi {
    position: relative;
    margin-bottom: 10px;
    background-color: var(--color-block-background);
    border: 1px solid var(--color-block-background);
    border-radius: 10px;
    padding: 15px;
    cursor: pointer;

    .top {
        display: flex;
        column-gap: 15px;

        .preview {
            position: relative;
            width: 70px;
            height: 100px;

            background-size: cover;
            background-position: center right;
            border-radius: 10px;
            background-repeat: no-repeat;

            &.default {
                background-size: contain;
                background-position: top center;
            }

            .loader {
                transform: translate(-50%, -50%) scale(0.5);
            }

        }

        .main {
            flex: 1;
        }

        margin-bottom: 0px;
        transition: margin-bottom 0.5s ease-in-out;

    }

    .date {
        font-size: 12px;
        color: var(--color-text-description);
        margin-bottom: 2px;
    }

    .title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 2px;
    }

    .body {
        font-weight: 500;
    }

    .details {

        .picture {
            margin-bottom: 15px;
            height: 0px;
            padding-top: 50%;
            background-size: cover;
            background-position: center center;
            border-radius: 10px;
            overflow: hidden;
        }

        &.collapse-enter-active,
        &.collapse-leave-active {
            transition: max-height 0.4s ease, opacity 0.3s ease;
        }

        &.collapse-enter-from,
        &.collapse-leave-to {
            max-height: 0;
            opacity: 0;
            overflow: hidden;
        }

        &.collapse-enter-to,
        &.collapse-leave-from {
            max-height: 300px;
            opacity: 1;
        }
    }

    &.expanded {
        .top {
            margin-bottom: 15px;
        }


    }

    &.unread {
        border-color: var(--color-color10);
    }

    &.order {
        .preview {
            background-color: var(--color-color8);
            max-height: 68px;
            background-size: auto !important;
            background-position: center center !important;
        }

        .title {
            color: var(--color-color12);
        }
    }


}
</style>